export default __webpack_public_path__ + "static/media/regolamento.ef3789d6.pdf";